var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDatabase = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24V30.6585C0 33.622 6.70139 36 15 36C23.2986 36 30 33.622 30 30.6585V24C26.4236 26.378 20.4167 27.3293 15 27.3293C9.58333 27.3293 3.57639 26.378 0 24Z",
    fill: "#858585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.3659C9.58333 15.3659 3.57639 14.4146 0 12V18.6951C0 21.622 6.70139 24 15 24C23.2986 24 30 21.622 30 18.6585V12C26.4236 14.4146 20.4167 15.3659 15 15.3659Z",
    fill: "#858585"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12C23.2843 12 30 9.31371 30 6C30 2.68629 23.2843 0 15 0C6.71573 0 0 2.68629 0 6C0 9.31371 6.71573 12 15 12Z",
    fill: "#858585"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDatabase);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/database.9446fc63833c2573c8082e7d275e2891.svg";